<!-- Компактный статус-действие; не меняет прочитанность без явного нажатия. -->
<template>
  <BaseTooltip ref="tooltip" :text="actionLabel" position="top">
    <base-button
      class="notification-read-state"
      variant="ghost"
      :icon="read ? 'circleCheck' : 'circle'"
      :icon-size="14"
      :disabled="disabled"
      :aria-busy="busy"
      :aria-label="`${busy ? 'Обновляем статус уведомления' : actionLabel}${title ? ': ' + title : ''}`"
      @click="toggle"
    />
  </BaseTooltip>
</template>

<script>
export default {
  name: "NotificationListReadState",
  props: {
    title: { type: String, default: "" },
    read: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ["toggle"],
  computed: {
    actionLabel() {
      return this.read ? "Отметить непрочитанным" : "Отметить прочитанным";
    },
  },
  methods: {
    toggle(event) {
      this.$refs.tooltip.hideTooltip();
      this.$emit("toggle", event);
    },
  },
};
</script>

<style scoped>
.notification-read-state.btn {
  height: 28px;
  min-height: 28px;
  width: 28px;
  padding: 0;
  border-radius: 6px;
  color: color-mix(in srgb, var(--color-dark) 60%, var(--color-light));
}
.notification-read-state.btn:hover:not(:disabled),
.notification-read-state.btn:focus-visible {
  background: color-mix(in srgb, var(--color-green) 10%, var(--color-light));
  color: var(--color-dark);
}
@media (pointer: coarse) {
  .notification-read-state.btn {
    min-height: 44px;
    min-width: 44px;
  }
}
</style>
